// Copyright (c) 2026 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { HardfinTabCardWrapper } from '@/components/hardfin-tab-card-wrapper';
import { Link } from '@/components/link';
import { useContact } from '@/contact/hooks/use-contact';
import { Box, Stack, Typography } from '@mui/material';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/contacts/$contactKey/')({
  component: ContactIndexRoute,
});

function ContactIndexRoute() {
  const { contactKey } = Route.useParams();
  const { contact } = useContact(contactKey);

  return (
    <HardfinTabCardWrapper title="Contact details">
      <Stack direction="row" spacing={4} paddingTop={2}>
        <Box sx={{ width: '50%' }}>
          <Stack spacing={2}>
            <Stack spacing={0.5}>
              <Typography variant="subtitle2">Company</Typography>
              <Link
                to="/companies/$companyKey"
                params={{ companyKey: contact.customer.key }}
                variant="body2"
                color="text.primary"
              >
                {contact.customer.name}
              </Link>
            </Stack>
            <Stack spacing={0.5}>
              <Typography variant="subtitle2">Title</Typography>
              <Typography variant="body2">{contact.title ?? '-'}</Typography>
            </Stack>
            <Stack spacing={0.5}>
              <Typography variant="subtitle2">Email</Typography>
              <Typography variant="body2">{contact.email ?? '-'}</Typography>
            </Stack>
            <Stack spacing={0.5}>
              <Typography variant="subtitle2">Phone</Typography>
              <Typography variant="body2">{contact.phone ?? '-'}</Typography>
            </Stack>
          </Stack>
        </Box>
        <Box sx={{ width: '50%' }}>
          <Stack spacing={0.5}>
            <Typography variant="subtitle2">Comments</Typography>
            <Typography variant="body2" sx={{ whiteSpace: 'pre-line' }}>
              {contact.comments ?? '-'}
            </Typography>
          </Stack>
        </Box>
      </Stack>
    </HardfinTabCardWrapper>
  );
}
